module.exports = __webpack_public_path__ + "static/img/third2_1_active.f57d58fc.png";